/**
 * Step Four: Register / Sign In
 */
import React from 'react'
import PropTypes from 'prop-types'
import SignForm from '../../../components/sign-up-sign-in-form'

const Four = ({ moveToNextStep, history, location }) => {
  return (
    <SignForm
      onSuccess={moveToNextStep}
      history={history}
      location={location}
      initSignUpForm={false}
    />
  )
}

// don't display this step if we're already logged in
Four.shouldDisplayStep = ({ isAuthenticated }) => !isAuthenticated

Four.propTypes = {
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired
}

export default Four
